import { PermissionType } from './permissionType';

export enum RoleType {
  Superadmin = 'Superadmin',
  Admin = 'Admin',
  BackOffice = 'BackOffice',
  ComplianceOfficer = 'ComplianceOfficer',
  LegalOfficer = 'LegalOfficer',
  MiddleOffice = 'MiddleOffice',
  RiskManager = 'RiskManager',
  FrontOffice = 'FrontOffice',
  SettlementSpecialist = 'SettlementSpecialist',
}
export interface UserRoleEntity {
  name: RoleType;
  permissions: PermissionType[];
}
